import { api } from '@/api/client'

export interface JoinResponse {
    token: string
    nickname: string
    participantId: number
    phase: string
    groupName: string
}

/** Tritt einer laufenden Runde bei. Der einzige Aufruf ohne Token. */
export function joinSession(code: string, nickname: string): Promise<JoinResponse> {
    return api<JoinResponse>('/join', {
        method: 'POST',
        anonymous: true,
        body: { code: code.trim().toUpperCase(), nickname: nickname.trim() },
    })
}
